import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Select, FormControl, InputLabel } from '@material-ui/core';

const CssSelect = withStyles({
  root: {
    '& .MuiInputBase-root': {
      minWidth: 125,
      '&.Mui-focused fieldset': {
        borderColor: '#00AAFC'
      },
      '&.Mui-focused .MuiSelect-root': {
        backgroundColor: '#FFFFFF'
      }
    }
  }
})(FormControl);

interface Props {
  id: string;
  title: string;
  handleChange: any;
  handleBlur: any;
  options: any;
  value: any;
}

const OutlinedSelect = (props: Props) => {
  return (
    <CssSelect variant="outlined" margin="normal">
      <InputLabel>{props.title}</InputLabel>
      <Select native id={props.id} value={props.value} onChange={props.handleChange} onBlur={props.handleBlur}>
        {props.options}
      </Select>
    </CssSelect>
  );
};
export default OutlinedSelect;
